import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { FormSection } from 'redux-form';
import { Checkbox } from 'semantic-ui-react';

import FormField from '~/views/common/FormField';
import Section from '~/views/common/Section';

import { fmt } from '~/utils';


const FeatureFlags = ({ feature_flags }) => (
    <Section name="Feature Flags">
        <FormSection name="feature_flags">
            { feature_flags.map(({ name }) => (
                <FormField
                    key={name}
                    label={fmt(name)}
                    name={name}
                    control={Checkbox}
                    toggle
                />
            )) }
        </FormSection>
    </Section>
);

FeatureFlags.propTypes = {
    feature_flags: arrayOf(shape({
        name: string.isRequired,
    }).isRequired).isRequired,
};

export default FeatureFlags;
